<template>
  <div class="header">
    <div class="top animated fadeInDown" v-if="navFlag">
      <ul class="navs clearfix">
        <li class="fl">
          <router-link :class="{ active: activeUrl == '/index' }" to="/index" aria-label="科研人才网-高校教师硕士博士科研招聘平台"
            >首页</router-link
          >
        </li>
        <li class="fl navPar">
          <router-link
            class="fl"
            :class="{ active: activeUrl == '/university' }"
            to="/university"
            aria-label="科研人才网-高校教师博士科研人才招聘"
            >高等院校</router-link
          >
          <ul class="navList clearfix">
            <!-- animated bounceInDown -->
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/university',
                    childName: '普通本科',
                    parentName: '高等院校',
                    categoryCode: 'pu_tong_ben_ke',
                  },
                }"
                aria-label="普通本科：科研人才网-本科高校教师博士科研人才招聘"
                >普通本科</router-link
              >
            </li>
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/university',
                    childName: '高职院校',
                    parentName: '高等院校',
                    categoryCode: 'gao_zhi_yuan_xiao',
                  },
                }"
                aria-label="高职院校：科研人才网-职业院校教师博士科研人才招聘"
                >高职院校</router-link
              >
            </li>
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/university',
                    childName: '教学科研',
                    parentName: '高等院校',
                    categoryCode: 'gao_deng_jiao_xue_ke_yan',
                  },
                }"
                aria-label="科研人才网-高校教师博士科研岗位人才招聘"
                >教学科研</router-link
              >
            </li>
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/university',
                    childName: '教辅岗位',
                    parentName: '高等院校',
                    categoryCode: 'jiao_fu_gang_wei',
                  },
                }"
                aria-label="科研人才网-高校教师博士教辅岗位人才招聘"
                >教辅岗位</router-link
              >
            </li>
          </ul>
        </li>
        <li class="fl navPar">
          <router-link
            class="fl"
            :class="{ active: activeUrl == '/researchInstitute' }"
            to="/researchInstitute"
            aria-label="科研人才网-科研院所博士科研岗位人才招聘"
            >科研院所</router-link
          >
          <ul class="navList clearfix">
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/researchInstitute',
                    childName: '教学科研',
                    parentName: '科研院校',
                    categoryCode: 'ke_yan_jiao_xue_ke_yan',
                  },
                }"
                aria-label="科研人才网-科研院所博士教学科研人才招聘"
                >教学科研</router-link
              >
            </li>
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/researchInstitute',
                    childName: '行政岗位',
                    parentName: '科研院校',
                    categoryCode: 'xing_zheng_gang_wei',
                  },
                }"
                aria-label="科研人才网-科研院所硕博行政岗位人才招聘"
                >行政岗位</router-link
              >
            </li>
          </ul>
        </li>
        <li class="fl navPar">
          <router-link
            class="fl"
            :class="{ active: activeUrl == '/medicine' }"
            to="/medicine"
            aria-label="科研人才网-医药卫生硕士博士科研人才招聘"
            >医药卫生</router-link
          >
        </li>
        <li class="fl navPar">
          <router-link
            class="fl"
            :class="{ active: activeUrl == '/famousCom' }"
            to="/famousCom"
            aria-label="科研人才网-知名企业硕士博士科研人才招聘"
            >知名企业</router-link
          >
        </li>
        <li class="fl navPar">
          <router-link
            class="fl"
            :class="{ active: activeUrl == '/Institution' }"
            to="/Institution"
            aria-label="科研人才网-事业单位硕士博士科研人才招聘"
            >事业单位</router-link
          >
          <ul class="navList clearfix">
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/Institution',
                    childName: '引才专项',
                    parentName: '事业单位',
                    categoryCode: 'yin_cai_zhuan_xiang',
                  },
                }"
                aria-label="科研人才网-硕士博士科研专项人才引进"
                >引才专项</router-link
              >
            </li>
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/Institution',
                    childName: '事业单位招聘',
                    parentName: '事业单位',
                    categoryCode: 'shi_ye_dan_wei_zhao_pin',
                  },
                }"
                aria-label="科研人才网-事业单位硕士博士人才招聘"
                >事业单位招聘</router-link
              >
            </li>
          </ul>
        </li>
        <li class="fl navPar">
          <router-link
            class="fl"
            :class="{ active: activeUrl == '/master' }"
            to="/master"
            aria-label="科研人才网-硕士博士人才招聘"
            >硕博热招</router-link
          >
          <ul class="navList clearfix">
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/master',
                    childName: '硕士招聘',
                    parentName: '硕博热招',
                    categoryCode: 'shuo_shi_zhao_pin',
                  },
                }"
                aria-label="科研人才网-硕士科研人才招聘"
                >硕士招聘</router-link
              >
            </li>
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/master',
                    childName: '博士招聘',
                    parentName: '硕博热招',
                    categoryCode: 'bo_shi_zhao_ping',
                  },
                }"
                aria-label="科研人才网-博士科研人才招聘"
                >博士招聘</router-link
              >
            </li>
          </ul>
        </li>
        <!-- <li class="fl navPar">
                        <router-link class="fl" :class="{'active':activeUrl =='/career'}" to="/career">职业情报</router-link>
                    </li> -->
        <li class="fl navPar">
          <router-link
            class="fl"
            :class="{ active: activeUrl == '/postdoctoral' }"
            to="/postdoctoral"
            aria-label="科研人才网-博后科研人才招聘"
            >博后进站</router-link
          >
          <ul class="navList clearfix">
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/postdoctoral',
                    childName: '高校博后',
                    parentName: '博后进站',
                    categoryCode: 'gao_xiao_bo_hou',
                  },
                }"
                aria-label="科研人才网-高校博后科研人才招聘"
                >高校博后</router-link
              >
            </li>
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/postdoctoral',
                    childName: '科研院所博后',
                    parentName: '博后进站',
                    categoryCode: 'ke_yan_yuan_suo_bo_hou',
                  },
                }"
                aria-label="科研人才网-研究院博后科研人才招聘"
                >科研院所博后</router-link
              >
            </li>
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/postdoctoral',
                    childName: '企业博后',
                    parentName: '博后进站',
                    categoryCode: 'qi_ye_bo_hou',
                  },
                }"
                aria-label="科研人才网-企业博后科研人才招聘"
                >企业博后</router-link
              >
            </li>
            <!-- <li><router-link :to="{path:'/moreList',query:{parentUrl:'/postdoctoral',childName:'国外博后',parentName:'博后进站',categoryCode:'guo_wai_bo_hou'}}">国外博后</router-link></li> -->
          </ul>
        </li>
        <li class="fl navPar">
          <router-link
            class="fl"
            :class="{ active: activeUrl == '/expert' }"
            to="/expert"
            aria-label="科研人才网-高级科研人才引进"
            >高端职位</router-link
          >
          <ul class="navList clearfix">
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/expert',
                    childName: '中高层管理人才',
                    parentName: '高端职位',
                    categoryCode: 'zhong_gao_ceng_guan_li',
                  },
                }"
                aria-label="科研人才网-高校中高层管理人才引进"
                >中高层管理人才</router-link
              >
            </li>
            <!-- <li><router-link  :to="{path:'/moreList',query:{parentUrl:'/expert',childName:'博后进站',parentName:'高端职位',categoryCode:'te_ping_zhuan_jia'}}">博后进站</router-link></li> -->
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/expert',
                    childName: '学术带头人',
                    parentName: '高端职位',
                    categoryCode: 'xue_shu_dai_tou_ren',
                  },
                }"
                aria-label="科研人才网-高校学术带头人引进"
                >学术带头人</router-link
              >
            </li>
          </ul>
        </li>
        <li class="fl navPar">
          <router-link
            class="fl"
            :class="{ active: activeUrl == '/foreignProjects' }"
            to="/foreignProjects"
            aria-label="科研人才网-国外博士科研人才招聘"
            >国外项目</router-link
          >
          <ul class="navList clearfix">
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/foreignProjects',
                    childName: '博士招生',
                    parentName: '国外项目',
                    categoryCode: 'bo_shi_zhao_sheng',
                  },
                }"
                aria-label="科研人才网-国外名校博士招生"
                >博士招生</router-link
              >
            </li>
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/foreignProjects',
                    childName: '博后/研究员招聘',
                    parentName: '国外项目',
                    categoryCode: 'bo_hou_huo_yan_jiu_yuan_zhao_ping',
                  },
                }"
                aria-label="科研人才网-国外名校博后/研究员招聘"
                >博后/研究员招聘</router-link
              >
            </li>
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/foreignProjects',
                    childName: '访问学者',
                    parentName: '国外项目',
                    categoryCode: 'fang_wen_xue_zhe',
                  },
                }"
                aria-label="科研人才网-国外名校访问学者招聘"
                >访问学者</router-link
              >
            </li>
          </ul>
        </li>
        <li class="fl navPar">
          <router-link
            class="fl"
            :class="{ active: activeUrl == '/returnee' }"
            to="/returnee"
            aria-label="科研人才网-海归硕士博士人才引进"
            >海归引进</router-link
          >
          <ul class="navList clearfix">
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/returnee',
                    childName: '硕士引进',
                    parentName: '海归引进',
                    categoryCode: 'shuo_shi_yin_jin',
                  },
                }"
                aria-label="科研人才网-海归硕士人才引进"
                >硕士引进</router-link
              >
            </li>
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/returnee',
                    childName: '博士引进',
                    parentName: '海归引进',
                    categoryCode: 'bo_shi_yin_jin',
                  },
                }"
                aria-label="科研人才网-海归博士人才引进"
                >博士引进</router-link
              >
            </li>
          </ul>
        </li>
        <li class="fl navPar">
          <router-link
            class="fl"
            :class="{ active: activeUrl == '/science' }"
            to="/science"
            aria-label="科研人才网-科创人才项目引进"
            >科创专区</router-link
          >
        </li>
        <!-- <li class="fl navPar">
                        <router-link class="fl" :class="{'active':activeUrl =='/partTime'}" to="/partTime">社会兼职</router-link>
                    </li> -->
      </ul>
    </div>
    <div class="container">
      <h3 class="clearfix">
        <p class="titles fl">专业的科研人才供需平台</p>
        <div class="fr titleRight">
          <i class="fl" @click="subscription">我要订阅</i>
          <span class="fl">|</span>
          <span class="fl" v-if="!loginPersonFlag && !loginCompanyFlag">
            <router-link :to="{ path: '/login', query: { loginFlag: true } }"
              >用户登录/注册</router-link
            >|
            <router-link :to="{ path: '/login', query: { loginFlag: false } }"
              >单位登录</router-link
            >
          </span>
          <div class="fl userDetail" v-if="loginPersonFlag || loginCompanyFlag">
            <p>{{ userNmae }}</p>
            <div class="lofinOut">
              <p v-if="loginPersonFlag">
                <router-link target="_blank" to="/personalCenter"
                  >个人中心</router-link
                >
              </p>
              <p v-if="loginCompanyFlag">
                <router-link target="_blank" to="/companyCerter"
                  >单位中心</router-link
                >
              </p>
              <p @click="logOut">退出登陆</p>
            </div>
          </div>
          <!-- <span class="fl">|</span>
                        <router-link class="fl" to="">高校大全</router-link> -->
        </div>
      </h3>
      <p class="threee clearfix" v-if="oneDataList1">
        <router-link
          target="_blank"
          class="fl"
          :to="{
            path: '/jobDetail',
            query: { jobDetailId: oneDataList1.recruitId },
          }"
          ><img :src="oneDataList1.img" alt="科研人才网-高校教师博士科研人才招聘"
        /></router-link>
        <router-link
          target="_blank"
          class="fl"
          :to="{
            path: '/jobDetail',
            query: { jobDetailId: oneDataList2.recruitId },
          }"
          ><img :src="oneDataList2.img" alt="科研人才网-本科高校教师博士科研人才招聘"
        /></router-link>
        <router-link
          target="_blank"
          class="fl"
          :to="{
            path: '/jobDetail',
            query: { jobDetailId: oneDataList3.recruitId },
          }"
          ><img :src="oneDataList3.img" alt="科研人才网-职业院校教师博士科研人才招聘"
        /></router-link>
      </p>
      <p class="one" v-if="oneDataList4">
        <router-link
          target="_blank"
          :to="{
            path: '/jobDetail',
            query: { jobDetailId: oneDataList4.recruitId },
          }"
          ><img :src="oneDataList4.img" alt="科研人才网-高校教师博士科研岗位人才招聘"
        /></router-link>
      </p>
      <div class="searchBar clearfix">
        <h1>
          <router-link :to="{ path: 'http://www.keyanhr.cn/' }"
            ><img
              class="fl"
              style="width: 230px; height: 56px"
              src="@/assets/imgs/Group 10.png"
              alt="logo"
              @click="refreshPage"
          /></router-link>
        </h1>
        <p class="clearfix fl">
          <input
            type="text"
            v-model="inputVal"
            class="fl"
            placeholder="请输入关键词"
          />
          <img
            @click="searchWord"
            class="fl"
            src="@/assets/imgs/Group 11.png"
            alt="科研人才网-高校教师博士教辅岗位人才招聘"
          />
        </p>
        <router-link
          v-if="!loginPersonFlag && !loginCompanyFlag"
          class="fl toPublic"
          :to="{ path: '/login', query: { loginFlag: false } }"
          ><img src="@/assets/imgs/Group 12.png" alt="科研人才网-科研院所博士科研岗位人才招聘"
        /></router-link>
        <router-link
          v-if="!loginPersonFlag && !loginCompanyFlag"
          class="fl toLogin"
          :to="{ path: '/login', query: { loginFlag: true } }"
          ><img src="@/assets/imgs/Group 13.png" alt="科研人才网-科研院所博士教学科研人才招聘"
        /></router-link>
      </div>
      <ul class="navs clearfix">
        <li class="fl">
          <router-link :class="{ active: activeUrl == '/index' }" to="/index"
            >首页</router-link
          >
        </li>
        <li class="fl navPar">
          <router-link
            class="fl"
            :class="{ active: activeUrl == '/university' }"
            to="/university"
            >高等院校</router-link
          >
          <ul class="navList clearfix">
            <!-- animated bounceInDown -->
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/university',
                    childName: '普通本科',
                    parentName: '高等院校',
                    categoryCode: 'pu_tong_ben_ke',
                  },
                }"
                >普通本科</router-link
              >
            </li>
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/university',
                    childName: '高职院校',
                    parentName: '高等院校',
                    categoryCode: 'gao_zhi_yuan_xiao',
                  },
                }"
                >高职院校</router-link
              >
            </li>
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/university',
                    childName: '教学科研',
                    parentName: '高等院校',
                    categoryCode: 'gao_deng_jiao_xue_ke_yan',
                  },
                }"
                >教学科研</router-link
              >
            </li>
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/university',
                    childName: '教辅岗位',
                    parentName: '高等院校',
                    categoryCode: 'jiao_fu_gang_wei',
                  },
                }"
                >教辅岗位</router-link
              >
            </li>
          </ul>
        </li>
        <li class="fl navPar">
          <router-link
            class="fl"
            :class="{ active: activeUrl == '/researchInstitute' }"
            to="/researchInstitute"
            >科研院所</router-link
          >
          <ul class="navList clearfix">
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/researchInstitute',
                    childName: '教学科研',
                    parentName: '科研院校',
                    categoryCode: 'ke_yan_jiao_xue_ke_yan',
                  },
                }"
                >教学科研</router-link
              >
            </li>
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/researchInstitute',
                    childName: '行政岗位',
                    parentName: '科研院校',
                    categoryCode: 'xing_zheng_gang_wei',
                  },
                }"
                >行政岗位</router-link
              >
            </li>
          </ul>
        </li>
        <li class="fl navPar">
          <router-link
            class="fl"
            :class="{ active: activeUrl == '/medicine' }"
            to="/medicine"
            >医药卫生</router-link
          >
        </li>
        <li class="fl navPar">
          <router-link
            class="fl"
            :class="{ active: activeUrl == '/famousCom' }"
            to="/famousCom"
            >知名企业</router-link
          >
        </li>
        <li class="fl navPar">
          <router-link
            class="fl"
            :class="{ active: activeUrl == '/Institution' }"
            to="/Institution"
            >事业单位</router-link
          >
          <ul class="navList clearfix">
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/Institution',
                    childName: '引才专项',
                    parentName: '事业单位',
                    categoryCode: 'yin_cai_zhuan_xiang',
                  },
                }"
                >引才专项</router-link
              >
            </li>
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/Institution',
                    childName: '事业单位招聘',
                    parentName: '事业单位',
                    categoryCode: 'shi_ye_dan_wei_zhao_pin',
                  },
                }"
                >事业单位招聘</router-link
              >
            </li>
          </ul>
        </li>
        <li class="fl navPar">
          <router-link
            class="fl"
            :class="{ active: activeUrl == '/master' }"
            to="/master"
            >硕博热招</router-link
          >
          <ul class="navList clearfix">
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/master',
                    childName: '硕士招聘',
                    parentName: '硕博热招',
                    categoryCode: 'shuo_shi_zhao_pin',
                  },
                }"
                >硕士招聘</router-link
              >
            </li>
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/master',
                    childName: '博士招聘',
                    parentName: '硕博热招',
                    categoryCode: 'bo_shi_zhao_ping',
                  },
                }"
                >博士招聘</router-link
              >
            </li>
          </ul>
        </li>
        <!-- <li class="fl navPar">
                        <router-link class="fl" :class="{'active':activeUrl =='/career'}" to="/career">职业情报</router-link>
                    </li> -->
        <li class="fl navPar">
          <router-link
            class="fl"
            :class="{ active: activeUrl == '/postdoctoral' }"
            to="/postdoctoral"
            >博后进站</router-link
          >
          <ul class="navList clearfix">
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/postdoctoral',
                    childName: '高校博后',
                    parentName: '博后进站',
                    categoryCode: 'gao_xiao_bo_hou',
                  },
                }"
                >高校博后</router-link
              >
            </li>
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/postdoctoral',
                    childName: '科研院所博后',
                    parentName: '博后进站',
                    categoryCode: 'ke_yan_yuan_suo_bo_hou',
                  },
                }"
                >科研院所博后</router-link
              >
            </li>
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/postdoctoral',
                    childName: '企业博后',
                    parentName: '博后进站',
                    categoryCode: 'qi_ye_bo_hou',
                  },
                }"
                >企业博后</router-link
              >
            </li>
            <!-- <li><router-link :to="{path:'/moreList',query:{parentUrl:'/postdoctoral',childName:'国外博后',parentName:'博后进站',categoryCode:'guo_wai_bo_hou'}}">国外博后</router-link></li> -->
          </ul>
        </li>
        <li class="fl navPar">
          <router-link
            class="fl"
            :class="{ active: activeUrl == '/expert' }"
            to="/expert"
            >高端职位</router-link
          >
          <ul class="navList clearfix">
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/expert',
                    childName: '中高层管理人才',
                    parentName: '高端职位',
                    categoryCode: 'zhong_gao_ceng_guan_li',
                  },
                }"
                >中高层管理人才</router-link
              >
            </li>
            <!-- <li><router-link  :to="{path:'/moreList',query:{parentUrl:'/expert',childName:'博后进站',parentName:'高端职位',categoryCode:'te_ping_zhuan_jia'}}">博后进站</router-link></li> -->
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/expert',
                    childName: '学术带头人',
                    parentName: '高端职位',
                    categoryCode: 'xue_shu_dai_tou_ren',
                  },
                }"
                >学术带头人</router-link
              >
            </li>
          </ul>
        </li>
        <li class="fl navPar">
          <router-link
            class="fl"
            :class="{ active: activeUrl == '/foreignProjects' }"
            to="/foreignProjects"
            >国外项目</router-link
          >
          <ul class="navList clearfix">
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/foreignProjects',
                    childName: '博士招生',
                    parentName: '国外项目',
                    categoryCode: 'bo_shi_zhao_sheng',
                  },
                }"
                >博士招生</router-link
              >
            </li>
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/foreignProjects',
                    childName: '博后/研究员招聘',
                    parentName: '国外项目',
                    categoryCode: 'bo_hou_huo_yan_jiu_yuan_zhao_ping',
                  },
                }"
                >博后/研究员招聘</router-link
              >
            </li>
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/foreignProjects',
                    childName: '访问学者',
                    parentName: '国外项目',
                    categoryCode: 'fang_wen_xue_zhe',
                  },
                }"
                >访问学者</router-link
              >
            </li>
          </ul>
        </li>
        <li class="fl navPar">
          <router-link
            class="fl"
            :class="{ active: activeUrl == '/returnee' }"
            to="/returnee"
            >海归引进</router-link
          >
          <ul class="navList clearfix">
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/returnee',
                    childName: '硕士引进',
                    parentName: '海归引进',
                    categoryCode: 'shuo_shi_yin_jin',
                  },
                }"
                >硕士引进</router-link
              >
            </li>
            <li>
              <router-link
                :to="{
                  path: '/moreList',
                  query: {
                    parentUrl: '/returnee',
                    childName: '博士引进',
                    parentName: '海归引进',
                    categoryCode: 'bo_shi_yin_jin',
                  },
                }"
                >博士引进</router-link
              >
            </li>
          </ul>
        </li>
        <li class="fl navPar">
          <router-link
            class="fl"
            :class="{ active: activeUrl == '/science' }"
            to="/science"
            >科创专区</router-link
          >
        </li>
        <!-- <li class="fl navPar">
                        <router-link class="fl" :class="{'active':activeUrl =='/partTime'}" to="/partTime">社会兼职</router-link>
                    </li> -->
      </ul>
    </div>
    <el-dialog title="请选择要订阅的专业" :visible.sync="dialogFormVisible">
      <template>
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange"
          >全选</el-checkbox
        >
        <div style="margin: 15px 0 0"></div>
        <el-checkbox-group
          v-model="checkedMajor"
          @change="handleCheckedCitiesChange"
        >
          <el-checkbox
            style="margin-top: 10px; width: 70px"
            v-for="(item, key) in majorList"
            :label="item.dictValue"
            :key="key"
            >{{ item.dictLabel }}</el-checkbox
          >
        </el-checkbox-group>
        <p style="font-size: 12px; color: #999; margin-top: 30px">
          说明：订阅成功后，系统将最新的招聘咨询以邮件信息发送给您！
        </p>
      </template>
      <div slot="footer" class="dialog-footer clearfix">
        <el-button @click="cancelMajor" class="fl">取消订阅</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureMajor">确 定</el-button>
      </div>
    </el-dialog>
    <div class="minHeader clearfix">
      <router-link :to="{ path: '/index' }"
        ><img
          class="fl"
          style="width: 230px; height: 56px"
          src="@/assets/imgs/Group 10.png"
          alt="logo"
      /></router-link>
      <span class="menu fr" @click="drawer = true">
        <i class="el-icon-menu"></i>
      </span>
    </div>
    <el-drawer
      size="190px"
      :visible.sync="drawer"
      custom-class="drawerMenu"
      title="科研人才网"
      style=""
      direction="ltr"
    >
      <el-row>
        <el-col :span="24">
          <el-menu
            default-active="2"
            class="el-menu-vertical-demo"
            background-color="#545c64"
            text-color="#fff"
            active-text-color="#ffd04b"
          >
            <el-menu-item index="1">
              <router-link
                style="color: rgb(255, 255, 255)"
                class="fl"
                :class="{ active: activeUrl == '/university' }"
                to="/university"
                >高等院校</router-link
              >
            </el-menu-item>
            <el-menu-item index="2">
              <router-link
                style="color: rgb(255, 255, 255)"
                class="fl"
                :class="{ active: activeUrl == '/researchInstitute' }"
                to="/researchInstitute"
                >科研院所</router-link
              >
            </el-menu-item>
            <el-menu-item index="3">
              <router-link
                style="color: rgb(255, 255, 255)"
                class="fl"
                :class="{ active: activeUrl == '/medicine' }"
                to="/medicine"
                >医药卫生</router-link
              >
            </el-menu-item>
            <el-menu-item index="4">
              <router-link
                style="color: rgb(255, 255, 255)"
                class="fl"
                :class="{ active: activeUrl == '/famousCom' }"
                to="/famousCom"
                >知名企业</router-link
              >
            </el-menu-item>
            <el-menu-item index="5">
              <router-link
                style="color: rgb(255, 255, 255)"
                class="fl"
                :class="{ active: activeUrl == '/Institution' }"
                to="/Institution"
                >事业单位</router-link
              >
            </el-menu-item>
            <el-menu-item index="6">
              <router-link
                style="color: rgb(255, 255, 255)"
                class="fl"
                :class="{ active: activeUrl == '/master' }"
                to="/master"
                >硕博热招</router-link
              >
            </el-menu-item>
            <el-menu-item index="8">
              <router-link
                style="color: rgb(255, 255, 255)"
                class="fl"
                :class="{ active: activeUrl == '/postdoctoral' }"
                to="/postdoctoral"
                >博后进站</router-link
              >
            </el-menu-item>
            <el-menu-item index="9">
              <router-link
                style="color: rgb(255, 255, 255)"
                class="fl"
                :class="{ active: activeUrl == '/expert' }"
                to="/expert"
                >高端职位</router-link
              >
            </el-menu-item>
            <el-menu-item index="10">
              <router-link
                style="color: rgb(255, 255, 255)"
                class="fl"
                :class="{ active: activeUrl == '/foreignProjects' }"
                to="/foreignProjects"
                >国外项目</router-link
              >
            </el-menu-item>
            <el-menu-item index="11">
              <router-link
                style="color: rgb(255, 255, 255)"
                class="fl"
                :class="{ active: activeUrl == '/returnee' }"
                to="/returnee"
                >海归引进</router-link
              >
            </el-menu-item>
            <el-menu-item index="12">
              <router-link
                style="color: rgb(255, 255, 255)"
                class="fl"
                :class="{ active: activeUrl == '/science' }"
                to="/science"
                >科创专区</router-link
              >
            </el-menu-item>
            <el-menu-item index="13">
              <router-link
                style="color: rgb(255, 255, 255)"
                class="fl"
                :class="{ active: activeUrl == '/science' }"
                to="/login"
                >登录</router-link
              >
            </el-menu-item>
          </el-menu>
        </el-col>
      </el-row>
    </el-drawer>
  </div>
</template>
<script>
import { get, postWithJson, form } from "@/api/services";
export default {
  name: "header2",
  props: {
    // categoryList: {
    //     type: Array,
    //     default: []
    // },

    oneList: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      userNmae: "",
      navFlag: false,
      loginPersonFlag: false,
      loginCompanyFlag: false,
      // categoryDataList:[],
      oneDataList: {},
      oneDataList1: {},
      oneDataList2: {},
      oneDataList3: {},
      oneDataList4: {},
      activeUrl: "",
      inputVal: "",

      majorList: "",
      dialogFormVisible: false,
      checkAll: false,
      checkedMajor: [],
      isIndeterminate: false,
      majorOptions: [],

      drawer: false,
    };
  },
  mounted() {
    this.hasLogin();
    // 开启滚动监听
    this.activeUrl = this.$route.path;
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    refreshPage(){
      location.reload();
    },
    searchWord() {
      let routeData = this.$router.resolve({
        path: "/search",
        query: { inputFlag: this.inputVal },
      });
      window.open(routeData.href, "_blank");
    },
    hasLogin() {
      var _self = this;
      let userCoookie = this.getCookie("session_token");
      if (userCoookie == null || userCoookie == "") {
        // localStorage.setItem('_token', "");
        // localStorage.setItem('_id', "");
        // localStorage.setItem('_userName', "");
        // this.$message({
        //     message: "登陆过期，请重新登陆",
        //     type: 'success'
        // });
        // this.$router.push({ path:'/login'})
        return false;
      }
      let userNmae = localStorage.getItem("_userName");

      let myreg = /^1\d{10}$/;
      if (myreg.test(parseInt(userNmae))) {
        this.loginPersonFlag = true;
        this.userNmae = userNmae.slice(0, 3) + "****" + userNmae.slice(7, 12);
      }
      let myreg1 =
        /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
      if (myreg1.test(userNmae)) {
        this.loginCompanyFlag = true;
        this.userNmae =
          userNmae.slice(0, 3) + "****" + userNmae.slice(userNmae.indexOf("@"));
      }

      if (this.loginPersonFlag == true) {
        get("front/dict/getDict", { dictType: "zhuan_ye" }).then(
          function (response) {
            if (response.data.status) {
              _self.majorList = response.data.data;
              _self.majorList.map(function (val, index, arr) {
                _self.majorOptions.push(val.dictValue);
              });
            } else {
              console.log(response.data.message);
            }
          },
          function (response) {
            _self.$message({
              message: response.data.message,
              type: "error",
            });
          }
        );
      }
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 300) {
        this.navFlag = true;
      } else {
        this.navFlag = false;
      }
    },

    handleCheckAllChange(val) {
      this.checkedMajor = val ? this.majorOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedMajorLength = value.length;
      if (
        checkedMajorLength > 0 &&
        checkedMajorLength < this.majorOptions.length
      ) {
        this.isIndeterminate = true;
      }
      if (checkedMajorLength == this.majorOptions.length) {
        this.isIndeterminate = false;
      }
    },
    subscription() {
      let _self = this;
      if (this.loginPersonFlag == false) {
        this.$router.push({ path: "/login", query: { loginFlag: true } });
        this.$message({
          message: "请先登陆个人用户",
          type: "error",
        });
        return false;
      } else {
        var reqData = { tel: localStorage.getItem("_id") };
        postWithJson("front/user/getUserInfo", reqData).then(
          function (response) {
            if (response.data.status) {
              let _userId = response.data.data.id;
              let subscribe = response.data.data.subscribe;
              if (subscribe != "" && subscribe != null) {
                _self.checkedMajor = subscribe.split(",");
              }
              if (_userId == undefined || _userId == "") {
                _self.$message({
                  message: "请先完成个人简历",
                  type: "error",
                });
                return false;
              }
              _self.dialogFormVisible = true;
            } else {
              console.log(response.data.message);
            }
          },
          function (response) {
            _self.$message({
              message: response.data.message,
              type: "error",
            });
          }
        );
      }
    },
    cancelMajor() {
      let _self = this;
      postWithJson("front/companyInfo/setSubscribe", {
        id: localStorage.getItem("_userId"),
        subscribe: "",
      }).then(
        function (response) {
          _self.dialogFormVisible = false;
          if (response.data.status) {
            _self.$message({
              message: "取消成功！",
              type: "success",
            });
          }
        },
        function (response) {
          _self.dialogFormVisible = false;
          _self.$message({
            message: response.data.message,
            type: "error",
          });
        }
      );
    },
    sureMajor() {
      let _self = this;
      postWithJson("front/companyInfo/setSubscribe", {
        id: localStorage.getItem("_userId"),
        subscribe: _self.checkedMajor.join(","),
      }).then(
        function (response) {
          _self.dialogFormVisible = false;
          if (response.data.status) {
            _self.$message({
              message: "订阅成功！",
              type: "success",
            });
          }
        },
        function (response) {
          _self.dialogFormVisible = false;
          _self.$message({
            message: response.data.message,
            type: "error",
          });
        }
      );
    },

    logOut() {
      localStorage.setItem("_token", "");
      localStorage.setItem("_id", "");
      this.loginPersonFlag = false;
      this.loginCompanyFlag = false;
      localStorage.setItem("_userName", "");
      this.setCookie("session_token", "");
      this.$message({
        message: "退出成功！",
        type: "success",
      });
      this.$router.push({ path: "/login" });
    },
  },
  destroyed() {
    // localStorage.setItem('_userName', "");
    // localStorage.setItem('_token', "");
    // localStorage.setItem('_id', "");
    window.removeEventListener("scroll", this.handleScroll, true);
  },
  watch: {
    //   categoryList: {
    //       immediate: true,
    //       handler(val, oldval){
    //         this.categoryDataList = val;
    //       }
    //   },
    oneList: {
      deep: true,
      immediate: true,
      handler: function (val, oldval) {
        if (JSON.stringify(val) == "{}") {
          return false;
        }
        this.oneDataList = val;
        this.oneDataList1 = val[1][0];
        this.oneDataList2 = val[1][1];
        this.oneDataList3 = val[1][2];
        this.oneDataList4 = val[2][0];
      },
    },
  },
};
</script>
<style lang="less">
.drawerMenu {
  background-color: rgb(84, 92, 100);
  overflow-y: auto;
}
.drawerMenu header {
  color: #fff;
  background-color: rgb(84, 92, 100);
}
.el-menu-item,
.el-submenu__title {
  height: 40px !important;
  line-height: 40px !important;
}
.el-menu {
  border-right: none !important;
}
.el-drawer__open .el-drawer.ltr {
  background-color: rgb(84, 92, 100) !important;
}
</style>
<style scoped = "scoped"  lang = "less">
.header {
  background-color: #fff;
  height: 300px;
  /* overflow: hidden; */
  .minHeader {
    display: none;
  }
  .top {
    width: 100%;
    background: rgba(23, 135, 251, 1);
    position: fixed;
    z-index: 999;
    top: 0;
    .navs {
      width: 1200px;
      height: 50px;
      line-height: 50px;
      background: rgba(23, 135, 251, 1);
      padding: 0 20px 0 40px;
      box-sizing: border-box;
      margin: 0 auto;
      .navPar {
        position: relative;

        /* margin-top: 6px; */
        margin-left: 12px;
        .navList {
          display: none;
          position: absolute;
          width: 140px;
          left: -30px;
          text-align: center;
          margin-top: 46px;
          background-color: #1787fb;
          li {
            height: 50px;
            a {
              display: inline-block;
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .navPar:hover .navList {
        display: block;
      }
      a {
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        box-sizing: border-box;
        font-size: 16px;
        padding: 0 10px;
        height: 40px;
        line-height: 40px;
        margin-top: 6px;
        margin-left: 10px;
      }
      a:first-child {
        margin-left: 0;
      }
      .active {
        border-bottom: 4px solid #fff;
      }
    }
  }
  .container {
    width: 1200px;
    margin: 0 auto;
    padding-top: 10px;
    h3 {
      height: 20px;
      line-height: 20px;
      font-size: 12px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      margin-bottom: 10px;
      /* margin: 10px 0; */
      .titleRight {
        vertical-align: top;
        height: 20px;
      }
      .userDetail {
        position: relative;
        margin: 0 4px;
      }
      .lofinOut {
        display: none;
        position: absolute;
        top: 20px;
        left: 0;
        background-color: white;
        width: 100px;
        text-align: center;
        box-shadow: 4px 4px 2px #999;
        p {
          cursor: pointer;
          line-height: 24px;
        }
        a {
          display: block;
          margin: 0;
        }
      }
      .userDetail:hover .lofinOut {
        display: block;
      }
      .titles {
        font-size: 14px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: rgba(23, 135, 251, 1);
      }
      a,
      i {
        font-style: normal;
        color: rgba(51, 51, 51, 1);
        margin: 0 6px;
        cursor: pointer;
      }
      span {
        height: 20px;
        line-height: 20px;
      }
    }
    .threee {
      a {
        margin-left: 10px;
      }
      img {
        width: 393px;
        height: 50px;
        display: block;
      }
      a:first-child {
        margin-left: 0;
      }
      img:hover {
        box-shadow: 0 0 10px #333;
        transform: scale(1.01, 1.02);
      }
    }
    .one {
      margin-top: 10px;
      img {
        display: block;
        width: 1200px;
        height: 50px;
      }
      img:hover {
        box-shadow: 0 0 10px #333;
        transform: scale(1.01, 1.02);
      }
    }
    .searchBar {
      margin: 24px 0 20px;
      p {
        display: inline-block;
        margin-left: 10px;
        input {
          width: 544px;
          height: 56px;
          box-sizing: border-box;
          text-indent: 20px;
          font-size: 16px;
          border: 1px solid #ddd;
        }
        img {
          cursor: pointer;
        }
      }
      a {
        img {
          margin-left: 10px;
          display: block;
        }
      }
      .toPublic:hover,
      .toLogin:hover {
        opacity: 0.8;
      }
    }
    .navs {
      width: 1200px;
      height: 50px;
      line-height: 50px;
      background: rgba(23, 135, 251, 1);
      padding: 0 20px 0 40px;
      box-sizing: border-box;
      position: relative;
      z-index: 999;
      .navPar {
        position: relative;

        /* margin-top: 6px; */
        margin-left: 12px;
        .navList {
          display: none;
          position: absolute;
          width: 140px;
          left: -30px;
          text-align: center;
          margin-top: 46px;
          background-color: #1787fb;
          li {
            height: 50px;
            a {
              display: inline-block;
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .navPar:hover .navList {
        display: block;
      }
      a {
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        box-sizing: border-box;
        font-size: 16px;
        padding: 0 10px;
        height: 40px;
        line-height: 40px;
        margin-top: 6px;
        margin-left: 10px;
      }
      a:first-child {
        margin-left: 0;
      }
      .active {
        border-bottom: 4px solid #fff;
      }
    }
  }
}
@media all and (max-width: 768px) {
  .header {
    height: 70px;
    .top {
      display: none;
    }
    .container {
      display: none;
    }
    .minHeader {
      display: block;
      img {
        height: 35px;
        margin-top: 17px;
        margin-left: 20px;
      }
      .menu {
        display: inline-block;
        height: 70px;
        width: 70px;
        line-height: 70px;
        text-align: center;
      }
      .el-icon-menu {
        font-size: 30px;
        margin-top: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/header2.vue